import React from "react";
import { Link, useLocation } from "react-router-dom";
import Projects from "../../api/projects";
import Shape from "../../images/right-arrow-2.svg";

const ClickHandler = () => {
  window.scrollTo(0, 0);
};

const ProjectSection = ({ hclass }) => {
  const location = useLocation();

  const isHome = ["/home", "/aboutus", "/"].includes(location.pathname);

  // 👉 Directly use all projects (no filtering)
  const projectList = isHome
    ? Projects.slice(0, 4) // show only 4 on home
    : Projects; // show all on other pages

  return (
    <section className={hclass}>
      <div className="container-fulid">
        <div className="title">
          <h2 className="fade_bottom">Crafted Spaces</h2>
        </div>

        <div className="project-wrap">
          {projectList.map((project, index) => (
            <div className="project-card fade_bottom" key={project.id || index}>
              <img
                src={project.pimg}
                alt={project.title}
                className="project-img object-fit-cover"
              />
              <img
                src={project.pimg}
                alt={project.title}
                className="project-img object-fit-cover"
              />

              <div className="content">
                <h2 className="text-white">{project.title}</h2>
                <span>{project.subtitle}</span>
                <br />
                <span>{project.location}</span>
              </div>
            </div>
          ))}
        </div>

        {isHome && (
          <div className="project-allBtn fade_bottom">
            <Link onClick={ClickHandler} to="/our-projects" className="theme-btn">
              <span>See All Projects</span>
              <img src={Shape} alt="" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProjectSection;